import { Global, css } from "@emotion/react";
import React, { FC } from "react";
import { FONT_FAMILY_PRIMARY } from ".";
import { COLOR_WHITE } from "./colors";

const GlobalStyles: FC = () => (
  <Global
    styles={css`
      html {
        box-sizing: border-box;
      }

      body {
        background-color: ${COLOR_WHITE};
        font-family: ${FONT_FAMILY_PRIMARY};
        margin: 0;
        padding: 0;
      }

      // Handle MUI Paper for Select component (MUI v5)
      .MuiPaper-root:has(.MuiList-root) {
        border-radius: 0.5rem;
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.05) !important;
        margin-top: 0.25rem;

        .MuiList-root {
          padding: 0;
        }
      }
    `}
  />
);

export default GlobalStyles;
